module.exports = __webpack_public_path__ + "static/media/wiley_logo.cd51b13d.jpg";